<template>
<div>
    <SimpleInput :inputName="params.name" :inputValue="inputValue" @input-value-emitter="updateValue" />
</div>
</template>

<script>
import SimpleInput from "@/components/UI/inputs/SimpleInput.vue";

export default {
    name: "FilterInput",
    components: {SimpleInput},
    props: {
        params: {
            type: Object,
        },
        value: {
            type: String,
        },
    },
    data() {
        return {
            inputValue: this.value,
        };
    },
    methods: {
        updateValue({value}) {
            this.inputValue = value;
            this.$emit('input', value);
        },
    },
};
</script>

<style scoped>

</style>